"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _ContentItem = _interopRequireDefault(require("../../../shared/components/cms/ContentItem"));

var _map = _interopRequireDefault(require("lodash/map"));

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CustomError = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomError, _React$Component);

  var _super = _createSuper(CustomError);

  function CustomError() {
    _classCallCheck(this, CustomError);

    return _super.apply(this, arguments);
  }

  _createClass(CustomError, [{
    key: "_getErrorMessageText",
    value: function _getErrorMessageText(error, i) {
      if (error.errorMessageCmsKey) {
        return /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
          contentKey: error.errorMessageCmsKey,
          key: i
        });
      }

      if (error.errorMessageText) {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: i
        }, error.errorMessageText);
      }

      return /*#__PURE__*/_react.default.createElement("span", {
        key: i
      }, error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var hasErrors = this.props.errors && this.props.errors.length > 0;

      if (!hasErrors) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "input-message error-message"
      }, (0, _map.default)(this.props.errors, function (error, i) {
        return _this._getErrorMessageText(error, i);
      }));
    }
  }]);

  return CustomError;
}(_react.default.Component)) || _class;

CustomError.propTypes = {
  errors: _mobxReact.PropTypes.observableArray
};
var _default = CustomError;
exports.default = _default;